import { useState, FC, ReactNode } from 'react'
import { IoIosArrowForward, IoIosArrowDown } from 'react-icons/io'
import useFilter from '@components/Items/utils/hooks/useFilter'
import LoadingSpinner from '../../../elements/LoadingSpinner'

const Layout: FC<{ label: string; children: ReactNode }> = ({
  label,
  children,
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(
    ['CATEGORIES'].includes(label.toUpperCase())
  )
  const { isLoading } = useFilter()

  return (
    <div
      className={`relative items-center block border-black border-2 p-2 rounded-lg bg-white ${
        isLoading ? 'text-gray-200 pointer-events-none' : ''
      }`}
    >
      <button
        onClick={(e) => {
          e.preventDefault()
          e.stopPropagation()
          setIsOpen(!isOpen)
        }}
        className={'w-full'}
      >
        <div className={'flex justify-between items-center w-full'}>
          <h3 className={'font-bold text-sm'}>{label}</h3>
          {isOpen ? <IoIosArrowDown /> : <IoIosArrowForward />}
        </div>
      </button>
      {isOpen ? <div className="pt-2">{children}</div> : <></>}
      {isLoading ? (
        <div
          role="status"
          className="absolute -translate-x-1/2 -translate-y-1/2 top-2/4 left-1/2"
        >
          <LoadingSpinner />
          <span className="sr-only">Loading...</span>
        </div>
      ) : (
        <></>
      )}
    </div>
  )
}

export default Layout
